<script setup lang="ts">
import { useA11yStore } from '@/stores/a11y'

/**
 * Régions « live » pour lecteurs d'écran. Montée UNE SEULE FOIS dans `App.vue`,
 * à côté de `ToastHost`.
 *
 * ─── Pourquoi deux régions et non une ───
 *
 * `aria-live` ne se change pas à la volée de façon fiable : plusieurs lecteurs
 * d'écran mémorisent le niveau au moment où ils découvrent la région. Deux
 * régions distinctes, chacune avec son niveau figé, est la seule construction
 * qui fonctionne partout.
 *
 * ─── Pourquoi les régions existent DÈS le premier rendu ───
 *
 * Une région ajoutée au DOM en même temps que son texte n'est pas annoncée :
 * le lecteur d'écran doit avoir vu le conteneur AVANT pour surveiller ses
 * mutations. Les deux `<div>` sont donc toujours présents, vides la plupart du
 * temps. C'est l'erreur la plus courante avec `aria-live` — et la plus
 * silencieuse, puisque le code paraît juste.
 *
 * `aria-atomic="true"` : le message est relu en entier à chaque changement, et
 * non par différence. Sans lui, remplacer « 3 résultats » par « 13 résultats »
 * peut ne faire annoncer que « 1 ».
 */
const a11y = useA11yStore()
</script>

<template>
  <!-- `.sr-only` (assets/main.css) masque VISUELLEMENT sans retirer de l'arbre
       d'accessibilité — contrairement à `display:none` et `visibility:hidden`,
       qui rendraient le message inaudible pour tout le monde. -->
  <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">
    {{ a11y.politesse }}
  </div>
  <div class="sr-only" role="alert" aria-live="assertive" aria-atomic="true">
    {{ a11y.urgence }}
  </div>
</template>
